import { configureStore } from "@reduxjs/toolkit";
import createCaseAPIs from "./reducers/create-case-apis";
import fetchContactDetailsInfo from "./reducers/fetch-contact-details-info-apis";
import caseDetailsformReducer from "./reducers/case-deatis-form-reducer";
import formContactPrimarySlice from "./reducers/form-contact-primary-slice";
import formContactAlternateSlice from "./reducers/form-contact-alternate-slice";
import formEquipmentPhysicalShippingAddressSlice from "./reducers/form-equipment-physical-shipping-address-slice";
import formPartShippingAddressSlice from "./reducers/form-part-shipping-address-slice";
import filesUploadReducer from "./reducers/file-upload-reducers";
import loadingReducer from "./reducers/loadingSlice";
import searchCasesReducer from "./reducers/search-cases";
import bannerReducer from './reducers/bannerSlice';
import bulkUploadReducer from './reducers/bulkUploadSlice';
import customerAvailabilityReducer from "./reducers/customer-availability";

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  reducer: {
    createCaseAPI: createCaseAPIs,
    fetchContactDetailsInfoAPI: fetchContactDetailsInfo,
    caseDetailsform: caseDetailsformReducer,

    formContactPrimaryInfo: formContactPrimarySlice,
    formContactAlternateInfo: formContactAlternateSlice,
    
    formShippingAddressInfo: formEquipmentPhysicalShippingAddressSlice,
    formPartShippingAddressInfo: formPartShippingAddressSlice,
    customerAvailability: customerAvailabilityReducer,

    filesUpload: filesUploadReducer,
    loading: loadingReducer,
    searchCases: searchCasesReducer,
    banner: bannerReducer,
    bulkUploadCase: bulkUploadReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
